import { ReactNode } from "react";
import { NextLayoutComponentType } from "next";
import LiveHeader from "components/pages/sport/live/header/LiveHeader";
import Footer from "components/footer/Footer";
import MainContent from "components/MainContent";

const LiveLayout: NextLayoutComponentType = ({ children }) => (
    <MainContent>
        <LiveHeader />
        <div>{children}</div>
        <Footer />
    </MainContent>
);

const getLiveLayout = (page: ReactNode) => <LiveLayout>{page}</LiveLayout>;

export default getLiveLayout;
